import { NewsBannerType } from 'types/newsbanner';

export const newsBanners = [
    {
      active: false,
      hidden: false,
      id: 'refer',
      image: 'refer.png',
      heading: {
        en: 'Earn and Give Cash Rewards',
        de: ''
      },
      subHeading: {
        en: 'By Referring Friends',
        de: ''
      },
      link: '/rewards',
      imageClassName: 'w-[110px] h-[90px] lg:w-[185px] lg:h-[185px] justify-end -mb-4 -mt-2 -mr-2 -mb-4 -mt-2 lg:-mr-3',
      titleClassName: 'text-3xl lg:text-6xl leading-5 lg:leading-9',
      subtitletitleClassName: 'text-2xl lg:text-4xl'
    },
    {
      active: false,
      hidden: false,
      id: 'explore_stocks',
      image: 'stocks.png',
      heading: {
        "en": "Explore Tokenised Stocks",
        "de": "Explore Tokenised Stocks"
      },
      subHeading: {
        "en": "Trade US Stocks 24/7",
        "de": "Trade US Stocks 24/7"
      },
      link: '/products?type=stock',
      wrapperClassName: "bg-[#8952FF]",
      imageClassName: 'w-[111px] h-[94px] lg:w-[278px] lg:h-[236px] justify-end mb-0 mt-2 -mr-2 lg:-mr-3 lg:-ml-24',
      titleClassName: 'text-3xl lg:text-6xl leading-5 lg:leading-9 text-[#ffffff]',
      subtitletitleClassName: 'font-thin text-2xl lg:text-4xl text-[#ffffff]'
    },
    {
      active: true,
      hidden: false,
      id: 'insights',
      image: 'insights.png',
      mobileImage: 'insights.png',
      heading: {
        "en": "AI Insights",
        "de": "AI Insights",
      },
      subHeading: {
        "en": "Learn exactly what’s driving asset prices",
        "de": "Learn exactly what’s driving asset prices"
      },
      link: null,
      wrapperClassName: "bg-[#B393FF] py-3 lg:pt-3 overflow-hidden",
      imageClassName: 'w-[127px] h-[60px] lg:w-[227px] lg:h-[188px] justify-end -ml-12 -mb-3 lg:mt-2 lg:-mr-3 lg:-ml-24 lg:-mb-3',
      titleClassName: 'text-3xl lg:text-6xl leading-5 lg:leading-9 text-[#000000]',
      subtitletitleClassName: 'font-medium text-lg lg:text-4xl text-[#000000] md:pr-8 xxl:pr-28'
    },
    {
      active: true,
      hidden: false,
      id: 'explore_bundles',
      image: 'bundles.png',
      heading: {
        "en": "Explore Crypto Bundles",
        "de": "Explore Crypto Bundles"
      },
      subHeading: {
        "en": "Diversify Instantly",
        "de": "Diversify Instantly"
      },
      link: '/products?type=bundle',
      wrapperClassName: "bg-[#0C1C2C] border border-[#a4a7c1] pt-0.5 lg:pt-3 overflow-hidden",
      imageClassName: 'w-[90px] h-[70px] lg:w-[238px] lg:h-[188px] justify-end -mb-3 mt-2 mr-0 -ml-12 lg:-mr-3 lg:-ml-24 lg:mb-0',
      titleClassName: 'text-3xl lg:text-6xl leading-5 lg:leading-9 text-[#ffffff]',
      subtitletitleClassName: 'font-thin text-2xl lg:text-4xl text-[#ffffff]'
    }
  ] as NewsBannerType[];